import { Component } from '@angular/core';
import { MaliciousComponent } from 'app/components/malware/malicious/malicious.component';
import { MaliciousFileStatus } from '@imunify360-api/malicious';

@Component({
    selector: 'i360-restore-from-quarantine-malicious-action',
    template: `
        <i360-action
                [filter]="{status: status}"
                icon="fish"
                title="actions.restoreFromQuarantine"
                (perform)="malicious.changeItems('restore-from-quarantine', $event)">
        </i360-action>
    `,
})
export class RestoreFromQuarantineActionComponent {
    status = [MaliciousFileStatus.quarantined];
    constructor(public malicious: MaliciousComponent) {}
}
